module.exports = __webpack_public_path__ + "static/media/xiaomi_recent_1.4207ef5b.jpg";